import FormBox from './FormBox';
import FormBoxDivider from './FormBoxDivider';

export default FormBox;

export { FormBoxDivider };
